import { render, staticRenderFns } from "./Snakedetails.vue?vue&type=template&id=50cb33bc&lang=html&"
import script from "./Snakedetails.vue?vue&type=script&lang=js&"
export * from "./Snakedetails.vue?vue&type=script&lang=js&"
import style0 from "./Snakedetails.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports